import { API_PATH, API_PATH_FB } from './apiPath';

const APP_VERSION = 1.0;
const API_ENV = (process.env.NODE_ENV && process.env.NODE_ENV === 'production') ? process.env.NODE_ENV : 'development';
console.log("xzfsdfsfsdf",window.location.origin)
const Settings = {
  APP_VERSION,
  API_ROOT: API_PATH[API_ENV].API_ROOT,
  API_ROOT_FB: API_PATH_FB[API_ENV].API_ROOT_FB,
  S3_API_ROOT: API_PATH[API_ENV].S3_API_ROOT,
  PaymentTxnStatusCallBackTime: (process.env.NODE_ENV && process.env.NODE_ENV === 'production') ? 2000 : 3000,
  PaymentTxnStatusCallBackIteration: (process.env.NODE_ENV && process.env.NODE_ENV === 'production') ? 10 : 36,
  API_ERROR: 0,
  API_SUCCESS: 1,
  MESSAGES_TYPES: {
    TRUE: true,
    FALSE: false,
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    IN_PROGRESS: 'INPROGRESS',
    FAIL: 'FAIL'
  },
  UAT_URL: window.location.origin =='https://uat-nsws.investindia.gov.in/' ? 'https://uat-nsws-mnstrportal.investindia.gov.in/' : window.location.origin =='https://www.ppe.nsws.gov.in/' ? 'https://www.ppe-nodal-authority.nsws.gov.in/':window.location.origin=='https://www.demo.nsws.gov.in'?'https://www.demo-nodal-authority.nsws.gov.in/':window.location.origin=='https://www.nsws.gov.in'?'https://www.nodal-authority.nsws.gov.in/':'https://uat-nsws-mnstrportal.investindia.gov.in/',
  PAYMENT_FSSAI_URL:"https://uat-nsws.investindia.gov.in/",
  serverError: 'Something went wrong. Please try again later',
  DEFAULT_DATE_FORMAT: 'DD MMM YYYY',
  getHeaders(headers) {
    const HEADERS = {
      JSON: {
        'Content-Type': 'application/json',
      },
      URL_ENCODED: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      MULTIPART_FORM_DATA: {
        'Content-Type': 'multipart/form-data',
      },
      TEXT_HTML: {
        'Content-Type': 'text/html',
      },
      P2FORM: {
        'Content-Type': 'application/json',
        'access-id': 'MIN_TEST_0',
        'access-secret': 'MintesT@1234',
        'api-key': 'ApiKeyLicense#19',
        'Cookie': 'JSESSIONID=A99AE92D87D9C1D6565B17A63B34B2CD'
      },
      DIGIACCESSTOKEN: {
        'access-id': 'MIN_TEST_0',
        'access-secret': 'MintesT@1234',
        'api-key': 'ApiKeydigiAccessToken@06',
        'Content-Type': 'application/json',
        'Cookie': 'JSESSIONID=8F25E2CDC70B62BC13EB9CD5491B9373; JSESSIONID=07DD236597ED6DE051121EA301847DFB'
      },
      GST:{
        'api-key': 'ApiKeyGST@88',
        'Content-Type': 'application/json',
        'access-secret': 'MintesT@1234',
        'Cookie' : 'JSESSIONID=07DE836585976E631B5A05F8E30EFCF4; JSESSIONID=585BEF7E3B12C850FF851D14E78A8A25',
        'access-id': 'MIN_TEST_0',
      },
      DIGIDOC: {
        'access-id': 'MIN_TEST_0',
        'access-secret': 'MintesT@1234',
        'api-key': 'ApiKeydigiIssuedDocuments@07',
        'Content-Type': 'application/json',
        Cookie: 'JSESSIONID=8F25E2CDC70B62BC13EB9CD5491B9373; JSESSIONID=07DD236597ED6DE051121EA301847DFB'
      },
      DIGIPANDATA: {
        'access-id': 'MIN_TEST_0',
        'access-secret': 'MintesT@1234',
        'api-key': 'ApiKeydigiPanData@08',
        'Content-Type': 'application/json',
        Cookie: 'JSESSIONID=8F25E2CDC70B62BC13EB9CD5491B9373; JSESSIONID=07DD236597ED6DE051121EA301847DFB'
      },
      DIGIDATA: {
        'access-id': 'MIN_TEST_0',
        'access-secret': 'MintesT@1234',
        'api-key': 'ApiKeygetDigiPanData@09',
        'Content-Type': 'application/json',
        Cookie: 'JSESSIONID=8F25E2CDC70B62BC13EB9CD5491B9373; JSESSIONID=06607F772D40F9A7EFE4AF07CB399A45'
      },
    };
    function getHeaders() {
      let headerObj = [];
      Object.keys(headers).forEach(key => {
        const header = HEADERS[headers[key]];
        headerObj = Object.assign(headerObj, header);
      });
      return headerObj;
    }
    return getHeaders();
  },
};

export default Settings;
